export default __webpack_public_path__ + "static/media/anna.a9cf4fb2.png";